import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCharacter = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-smile-icon lucide-smile",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10
		}),
		/* @__PURE__ */ _jsx("path", { d: "M8 14s1.5 2 4 2 4-2 4-2" }),
		/* @__PURE__ */ _jsx("line", {
			x1: 9,
			x2: 9.01,
			y1: 9,
			y2: 9
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 15,
			x2: 15.01,
			y1: 9,
			y2: 9
		})
	]
});
export default SvgCharacter;
